import httpClient from './httpClient';

class ProcessTemplateService {
  constructor() {
    this.baseURL = '/api/process-templates';
  }

  /**
   * Get all process templates
   */
  async getTemplates(filters = {}) {
    try {
      // Build query params from filters
      const params = new URLSearchParams();
      
      if (filters.tool_category) params.append('tool_category', filters.tool_category);
      if (filters.diameter) params.append('diameter', filters.diameter);
      if (filters.total_length) params.append('total_length', filters.total_length);
      if (filters.edge_length) params.append('edge_length', filters.edge_length);
      if (filters.search) params.append('search', filters.search);
      if (filters.page) params.append('page', filters.page);
      if (filters.page_size) params.append('page_size', filters.page_size);
      
      const queryString = params.toString();
      const url = queryString ? `${this.baseURL}?${queryString}` : this.baseURL;
      
      const response = await httpClient.get(url);
      const data = response.data?.data || response.data;
      return data.items || data;
    } catch (error) {
      console.error('Error fetching process templates:', error);
      throw error;
    }
  }

  /**
   * Get a specific process template by ID
   */
  async getTemplate(id) {
    try {
      const response = await httpClient.get(`${this.baseURL}/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error fetching process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Create a new process template
   */
  async createTemplate(data) {
    try {
      const response = await httpClient.post(this.baseURL, data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error creating process template:', error);
      throw error;
    }
  }

  /**
   * Update an existing process template
   */
  async updateTemplate(id, data) {
    try {
      const response = await httpClient.put(`${this.baseURL}/${id}`, data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error updating process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Delete a process template
   */
  async deleteTemplate(id) {
    try {
      const response = await httpClient.delete(`${this.baseURL}/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error deleting process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Clone a process template
   */
  async cloneTemplate(id, newName = null) {
    try {
      const data = newName ? { name: newName } : {};
      const response = await httpClient.post(`${this.baseURL}/${id}/clone`, data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error cloning process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Match process template for cost calculation
   */
  async matchForCost(params) {
    try {
      const response = await httpClient.get(`${this.baseURL}/match-for-cost`, { params });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error matching process template:', error);
      throw error;
    }
  }
}

const processTemplateService = new ProcessTemplateService();
export default processTemplateService;
